import { SignupPageTemplate } from "@/templates/try/cloud/signup/signup-page/src";

export const SignupPage = () => <SignupPageTemplate />;
